import { AutocompleteProps } from "@/components/ui/autocomplete";
import DynamicSignerStampList, { SignerStamp } from "./DynamicSignerStampList";
import { useMemo } from "react";
export type SignersResolverProps = {
  onValue: (option: {
    value: string;
    label: string;
    type: "api" | "reference";
  } | {
    value: string;
    label: string;
    type: "api" | "reference";
  }[]) => void;
  institutionId: string;
  runningProcedureId?: string;
  referenceOptions?: {
    value: string;
    label: string;
    type: "reference";
  }[];
  useReferenceOptions?: boolean;
} & Omit<AutocompleteProps, "options" | "onChange">;
export function SignersResolver({
  initialValue,
  onValue,
  institutionId,
  referenceOptions
}: SignersResolverProps) {
  const rows = useMemo(() => {
    return typeof initialValue === "string" && initialValue ? JSON.parse(initialValue as string).map((row: any) => ({
      id: row.id || Date.now().toString(),
      user: {
        id: row.signerId,
        name: ""
      },
      role: {
        id: row.stampId,
        name: ""
      }
    })) : [{
      id: Date.now().toString(),
      user: null,
      role: null
    }];
  }, [initialValue]);
  const setRows = (rows: SignerStamp[]) => {
    onValue({
      value: JSON.stringify(rows.map(row => ({
        id: row.id,
        signerId: row.user?.id,
        stampId: row.role?.id
      }))),
      label: "label",
      type: "api"
    });
  };
  return <DynamicSignerStampList rows={rows} setRows={setRows} institutionId={institutionId} referenceOptions={referenceOptions} data-sentry-element="DynamicSignerStampList" data-sentry-component="SignersResolver" data-sentry-source-file="index.tsx" />;
}